module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('vpo', {
    attrs: {
      "type": "adhesion"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços Vale-pedágio")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.")]), _vm._v(" "), _c('p', [_vm._v("Totalmente digital, SEM CUSTO e fácil de usar.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-78b4dbf1!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/services-vpo.vue
// module id = 2175
// module chunks = 1